// src/components/UserContractView/utils/contractUtils.js

import {
  CheckCircle as SignedIcon,
  Pending as PendingIcon,
  Cancel as DeclinedIcon,
} from '@mui/icons-material';
import { CONTRACT_STATUS } from './contractConstants';

export const statusChipProps = (status) => {
  switch (status) {
    case CONTRACT_STATUS.SIGNED:
    case CONTRACT_STATUS.AGREED:
      return { color: 'success', icon: <SignedIcon /> };
    case CONTRACT_STATUS.DECLINED:
    case CONTRACT_STATUS.EXPIRED:
      return { color: 'error', icon: <DeclinedIcon /> };
    default:
      return { color: 'warning', icon: <PendingIcon /> };
  }
};

export const dateFromSignature = (sig = {}) =>
  sig.signed_at || sig.agreed_at || sig.declined_at || sig.created_at;

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    alert('Link copied!');
  } catch {
    alert('Failed to copy link');
  }
};

export const buildPublicLink = (assignmentId, blitzRoot) => 
  `${blitzRoot}/contract/${assignmentId}`;

export const isValidEmail = (email) => 
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString();
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleString();
};

export const getAssignmentId = (item) => {
  if (item?.template) return item.id;
  return item?.assignment?.id || item?.assignment_id;
};

export const getAssignment = (item) => {
  if (item?.template) return item;
  return item?.assignment;
};

export const getTemplate = (item) => {
  if (item?.template) return item.template;
  return item?.assignment?.template || {};
};